import { render, staticRenderFns } from "./AxFilesystemNodeClone.vue?vue&type=template&id=bad1c1f4&scoped=true&"
import script from "./AxFilesystemNodeClone.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemNodeClone.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemNodeClone.vue?vue&type=style&index=0&id=bad1c1f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad1c1f4",
  null
  
)

export default component.exports